module.exports = __webpack_public_path__ + "img/咖啡.1253ee69.png";